import { render, staticRenderFns } from "./coloursUpdatingIcon.vue?vue&type=template&id=18bc7f5b&"
import script from "./coloursUpdatingIcon.vue?vue&type=script&lang=js&"
export * from "./coloursUpdatingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports